"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Tabs component
 * @example
 * <Tabs name="Tab Navigation">
 *    <Tab name="Item 1">
 *       This is item one
 *    </Tab>
 *    <Tab name="Item 2">
 *       This is item two
 *    </Tab>
 * </Tabs>
 */
var Tabs = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Tabs, _React$PureComponent);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    var firstItem = Array.isArray(props.children) ? props.children[0] : props.children;
    _this.state = {
      value: props.initialValue || firstItem.props.value || firstItem.props.label
    };
    return _this;
  }
  /**
   * Handle tab item click event
   * @param {string} value - The value of the tab
   * @private
   */


  _createClass(Tabs, [{
    key: "_handleTabClick",
    value: function _handleTabClick(value, label) {
      var _this2 = this;

      this.setState({
        value: value
      }, function () {
        _this2.props.onChange(value);

        _this2.props.handleGATracking(label);
      });
    }
    /**
     * Returns a unique id for a tab item
     * @param prefix
     * @param key
     * @returns {string}
     * @private
     */

  }, {
    key: "_navId",
    value: function _navId(prefix, key) {
      return "".concat(prefix, "-tab-").concat(key).replace(/ /g, '-').toLowerCase();
    }
    /**
     *
     * @param {items} array of objects
     * see the readme.md to view the sample format
     *
     * Use of <NavLink /> to get the
     * current history/URL and renders
     * `active` className
     */

  }, {
    key: "_renderTabItems",
    value: function _renderTabItems(items, prefix) {
      var _this3 = this;

      return (items || []).map(function (item) {
        if (!item) {
          return null;
        }

        var value = item.props.value || item.props.label;

        var id = _this3._navId(prefix, item.props.label);

        return /*#__PURE__*/_react.default.createElement("button", {
          id: id,
          key: item.props.label,
          className: "tabs__navigation-item ".concat(value === _this3.state.value ? 'active' : ''),
          type: "button",
          "aria-label": item.props.label,
          role: "tab",
          onClick: _this3._handleTabClick.bind(_this3, value, item.props.label)
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "tabs__navigation-item__content",
          tabIndex: "-1"
        }, item.props.label));
      });
    }
    /**
     * Render tabs
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children;
      var items = Array.isArray(children) ? children : [children];
      var item = items.find(function (t) {
        return t.props.value === _this4.state.value || t.props.label === _this4.state.value;
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tabs"
      }, /*#__PURE__*/_react.default.createElement("div", {
        role: "tablist",
        "aria-label": name,
        className: "tabs__navigation"
      }, this._renderTabItems(items, name)), item && /*#__PURE__*/_react.default.createElement("div", {
        role: "tabpanel",
        tabIndex: "0",
        className: "tabs__tab",
        "aria-labelledby": this._navId(name, item.props.label)
      }, item));
    }
  }]);

  return Tabs;
}(_react.default.PureComponent);

exports.default = Tabs;

_defineProperty(Tabs, "propTypes", {
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  initialValue: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  handleGATracking: _propTypes.default.func
});

_defineProperty(Tabs, "defaultProps", {
  onChange: function onChange() {},
  initialValue: null,
  handleGATracking: function handleGATracking() {}
});
//# sourceMappingURL=Tabs.js.map